import { render, staticRenderFns } from "./UiTabHeaderItem.vue?vue&type=template&id=34cd88ae"
import script from "./UiTabHeaderItem.vue?vue&type=script&lang=js"
export * from "./UiTabHeaderItem.vue?vue&type=script&lang=js"
import style0 from "./UiTabHeaderItem.vue?vue&type=style&index=0&id=34cd88ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports